import React from 'react'
import Description from './Description'

/**
 * Gets the description of the discount and displays it in a pop-up box
 *
 * @param discountDescription - The description of the discount
 * @param discountName - The name of the discount
 * @param hoverTitle - The title of the pop-up box if not provided it will default to "Discount Description"
 *
 * @returns Component that display a pop-up box with a description of the discount
 */
function DiscountDescriptionBox({
   discountDescription,
   discountName,
   hoverTitle = 'Discount Description',
}) {
   if (!discountDescription) {
      return <>{discountName}</>
   }
   return (
      <Description
         title={hoverTitle}
         className={'width-text'}
         content={<>{discountDescription}</>}
      >
         {discountName}
      </Description>
   )
}

export default DiscountDescriptionBox
